import { useState } from 'react';
import { Box } from '@mui/material';
import colors from '../../../../assets/theme/base/colors';
import AppAccordion from '../../../../Component/Common/Components/Accordion/AppAccordion';
import { DeviationsDto } from '../../../../Component/Model/Dto/EmploymentEquity/Deviations';
import { EEOccupationalLevel } from '../../../../Component/Model/Enum/EmploymentEquity';
import { DesignatedDisabledPlanSummaryTable } from './DesignatedDisabledPlanSummaryTable';
import { OccupationalLevelJustificationsTable } from './OccupationalLevel/OccupationalLevelJustificationsTable';
import { DesignatedDisabledStatusChip, KeyReasonChip } from './AccordionHeaderChips';
import { JustificationSummaryStatCards } from './JustificationSummaryStatCards';

interface DesignatedDisabledAccordionProps {
    designatedDisabled: DeviationsDto.HeatmapDesignatedDisabledDto;
    periodHeading: string;
    justificationSummary: DeviationsDto.JustificationSummaryItemDto | null;
    onJustificationsChanged: () => void;
    defaultExpanded?: boolean;
}

export function DesignatedDisabledAccordion({ designatedDisabled, periodHeading, justificationSummary, onJustificationsChanged, defaultExpanded = false }: DesignatedDisabledAccordionProps) {
    const [hasExpanded, setHasExpanded] = useState<boolean>(defaultExpanded);

    return (
        <Box sx={{ mb: 1 }}>
            <AppAccordion
                expandOnDefault={defaultExpanded}
                onExpandChange={(expanded) => { if (expanded) setHasExpanded(true); }}
                label={
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Box component="span" sx={{ fontSize: '1.125rem', fontWeight: 700 }}>Disabled Employees</Box>
                        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '16px' }}>
                            <DesignatedDisabledStatusChip designatedDisabled={designatedDisabled} />
                            {justificationSummary && <KeyReasonChip captured={justificationSummary.eea2KeyJustifiableReasonCaptured} />}
                        </Box>
                    </Box>
                }
                height="56px"
            >
                <Box sx={{ fontSize: '1.25rem', fontWeight: 500, color: colors.dark.main, mb: 2 }}>
                    {periodHeading}
                </Box>
                <DesignatedDisabledPlanSummaryTable data={designatedDisabled} />
                {justificationSummary && <JustificationSummaryStatCards summary={justificationSummary} />}
                <Box sx={{ mt: 3 }}>
                    <OccupationalLevelJustificationsTable
                        occupationalLevelType={EEOccupationalLevel.Unspecified}
                        isDisabled={true}
                        isOpen={hasExpanded}
                        onJustificationsChanged={onJustificationsChanged}
                    />
                </Box>
            </AppAccordion>
        </Box>
    );
}
